import { gql } from '@apollo/client';

export const UPDATE_CANCEL_OFFER_PARAMETER = gql`
  mutation updateCancelOfferParameter($input: OfferCancelledStatesInput) {
    updateCancelOfferParameter(input: $input) {
      commandId
    }
  }
`;
